export default __webpack_public_path__ + "static/netlify-d753a40c6ece468220dd3887e33a79e8.png";